import { IconButton } from '@client:common/button';
import { Icon } from '@client:common/icon';

import './FilterDrawer.light.scss';
import './FilterDrawer.dark.scss';

interface Props {
  data: {
    info?: Array<{ id: number; title: string; description: string }>;
    filters: Array<{ id: number; value: string }>;
  };
  filterTitle: string;
  show: boolean;
  toggle: () => void;
}

export function FilterDrawer(props: Props) {
  const { filterTitle, data, show, toggle } = props;
  let drawerClasses = 'side-drawer';
  if (show) {
    drawerClasses = 'side-drawer open';
  }
  return (
    <div className={drawerClasses}>
      <div className='drawer-wrapper'>
        <div className='filter-drawer-header-container'>
          <div className='drawer-header-top'>
            <div className='header-top_row'>
              <h1 className='model-title'>{filterTitle}</h1>
              <IconButton
style='basic'
color='primary'
onClick={toggle}>
                <Icon
className='close-icon'
icon='close' />
              </IconButton>
            </div>
          </div>
        </div>
        <div className='filter-drawer-body-container'>
          {data &&
            data.info.map((item) => (
              <div
key={item.id}
className='filter-drawer-body-item'>
                <p className='filter-drawer_item-header'>{item.title}</p>
                <p className='filter-drawer_item-description'>{item.description}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
